// extracted by mini-css-extract-plugin
module.exports = {"policyButton":"Login_policyButton__3aFsJ","policyTooltip":"Login_policyTooltip__McZxH","show":"Login_show__aR1gU","closeButton":"Login_closeButton__2N8-7"};